import React, { useState } from "react";
import { AddCharge } from "../../pages";
import { ChargeController } from "../../controllers";
import { chargeStore } from "../../stores";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import * as yup from "yup";

const AddChargeContainer = ({ closeModal }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = () => {
    return yup.object().shape({
      name: yup.string().required("Enter Charge Name"),
      value: yup.string().required("Enter Value"),
    });
  };

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      name: values.name,
      type: values.type,
      minRange: values.minRange,
      maxRange: values.maxRange,
      value: values.value,
      businesses: values.businesses,
    };
    const { status, errorMessage } =
      await ChargeController.createCharge(payload);
    if (status === constant.Success) {
      closeModal();
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
    }
    setLoading(false);
    ChargeController.getCharges();
    return closeModal();
  };

  const currencyCodes = [
    {
      key: "NGN",
      value: "NGN",
    },
    {
      key: "USD",
      value: "USD",
    },
    {
      key: "GBP",
      value: "GBP",
    },
    {
      key: "EUR",
      value: "EUR",
    },
  ];

  return (
    <AddCharge
      currencyCodes={currencyCodes}
      closeModal={closeModal}
      onSubmit={onSubmit}
      loading={loading}
      validationSchema={validationSchema}
    />
  );
};
export default AddChargeContainer;
